import type { FaireProductEntity } from "../../entity_types/product";

export const p_xxs3f9s6jz: FaireProductEntity = {
  token: "p_xxs3f9s6jz",
  type: "product",
  name: "Only Cool People Hanging Decor",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/d99c014ca2a1bedd5b2ff57d62f67bb95e94f3576e813004a47d449719c50ba7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2a9b272fa6cc81a7713916f861d6204e1755f1167857a1c5a18d75fa3d7d488.jpeg",
    "https://cdn.faire.com/fastly/6ab30db2438753e20b3e50972c0c6e65c11b8cc98cef7c11650f826144f418a5.jpeg",
    "https://cdn.faire.com/fastly/261d056fd52dc247b08c845e202c8472f0a3890ee3a75c79b5d373f9d3a61a68.jpeg"
  ],
  priceDollars: 5,
  description: "A ready to hang metal tin sign from our Slow Living Collection displaying a hand illustrated design of a cute stuffed animals with a fun sentiment that reads \"Only Cool People Still Sleep With Stuffed Animals\" perfect for those who enjoy cozy home life. Cozy living sign features metal with embossed details for added dimension. Our Only Cool People metal wall décor is easy to hang against wall using the included mounting hardware and pre-drilled holes. A cozy living home accent that easily adds personality to any space.",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:28.385Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
